/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { SignupForm } from "./SignupForm";
import { Suspense, useState } from "react";
import { VerifyForm } from "../application/components/VerifyForm";
const SignupPage = (param)=>{
    let { params: { lng } } = param;
    const [toVerify, setToVerify] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    return /*#__PURE__*/ _jsx(Suspense, {
        children: !toVerify ? /*#__PURE__*/ _jsx(SignupForm, {
            lng: lng,
            handleEmail: (emailAddress)=>setEmail(emailAddress),
            handlePassword: (password)=>setPassword(password),
            handleVerify: (verify)=>setToVerify(verify)
        }) : /*#__PURE__*/ _jsx(VerifyForm, {
            lng: lng,
            email: email,
            password: password
        })
    });
};
export default SignupPage;
